/**
 * The merchant app (platform-app) that pairs with THIS admin host.
 *
 *   admin.dev.rubytill.com   → https://dev.rubytill.com
 *   admin.stage.rubytill.com → https://stage.rubytill.com
 *   admin.rubytill.com       → https://rubytill.com
 *   localhost                → http://localhost:3000
 *
 * Derived from the hostname at runtime, like the admin branding, because one
 * build serves every stage. `VITE_APP_URL` was a single build-time value and
 * pointed at a retired CafeMaster host, so every referral link built from it
 * sent merchants to the wrong site.
 *
 * Merchant and partner screens (sign-up, `#/affiliate/*`) live in platform-app,
 * which is a HashRouter; this app is a BrowserRouter, so a `/#/...` link on an
 * admin host silently lands on `/`. Always build those links from here.
 */
export function merchantAppUrl(): string {
  if (typeof window === 'undefined') return 'https://rubytill.com';
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return 'http://localhost:3000';
  if (host.startsWith('admin.')) return `https://${host.slice('admin.'.length)}`;
  return 'https://rubytill.com';
}

/** An absolute platform-app hash route, e.g. `merchantRoute('/affiliate/login')`. */
export function merchantRoute(path: string): string {
  return `${merchantAppUrl()}/#${path.startsWith('/') ? path : `/${path}`}`;
}
